module.exports = __webpack_public_path__ + "img/40_44.961e78ea.png";